import '@fontsource/special-elite/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/ibm-plex-mono/latin-600.css';
import './styles.css';
import { App } from './app';

const root = document.querySelector<HTMLElement>('#app');
if (!root) {
  throw new Error('Missing #app root');
}

const boot = document.querySelector<HTMLElement>('#boot');

void (async () => {
  try {
    const app = new App(root);
    await app.init();
    document.documentElement.classList.add('is-ready');
    boot?.remove();
  } catch (error) {
    console.error(error);
    if (boot) {
      boot.innerHTML = `<div class="boot-error">TERMINAL INITIALISATION FAILED<br/><small>${String(
        error,
      )
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')}</small></div>`;
    }
  }
})();
